module.exports = __webpack_public_path__ + "img/account-dashboard.e04f30b0.png";